// UserMenu.tsx
import { Avatar, Button, Menu, Text, Group } from "@mantine/core";
import { useMsal } from "@azure/msal-react";
import { UserAvatar } from "./UserAvatar";
import { DISABLE_AUTH } from "./flags";

export function UserMenu() {
  const { instance } = useMsal();
  if (DISABLE_AUTH) {
    return (
      <Group gap="xs">
        <Avatar radius="xl">DV</Avatar>
        <Text c="white">Developer</Text>
      </Group>
    );
  }
  const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0] ?? null;

  const name =
    account?.name || account?.idTokenClaims?.name || account?.username || "Okänd användare";

  const email = (account?.idTokenClaims as any)?.preferred_username || account?.username;

  const initials = name
    .split(" ")
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const onLogout = () =>
    instance.logoutRedirect({
      account: account ?? undefined,
      postLogoutRedirectUri: window.location.origin + "/auth/logout",
    });

  return (
    <Menu position="bottom-end" shadow="sm">
      <Menu.Target>
        <Button variant="subtle" px="xs">
          <Group gap="xs">
            <UserAvatar />
            {/* <Text c="white" fw={500} size="sm">
              {name}
            </Text> */}
          </Group>
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>Bruker</Menu.Label>
        <Menu.Item disabled>
          <Text fw={500}>{name}</Text>
          {email && (
            <Text size="xs" c="dimmed">
              {email}
            </Text>
          )}
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item color="red" onClick={onLogout}>
          Logg ut
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
